import { render, staticRenderFns } from "./common-option.vue?vue&type=template&id=48b52ecd&scoped=true"
import script from "./common-option.vue?vue&type=script&lang=js"
export * from "./common-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b52ecd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b52ecd')) {
      api.createRecord('48b52ecd', component.options)
    } else {
      api.reload('48b52ecd', component.options)
    }
    module.hot.accept("./common-option.vue?vue&type=template&id=48b52ecd&scoped=true", function () {
      api.rerender('48b52ecd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/iframe-page/components/common-option.vue"
export default component.exports